import pedidosApi from "@/app/services/pedidos";
import produtosApi from "@/app/services/produtos";
import { PAGINATION_OPTIONS } from "@/app/vuetifyConfig";

export default {
  namespaced: true,
  state: {
    pedido: null,
    pedidos: [],
    paginacao: {
      paginas: 0,
      registros: 0,
    },
    atualizar: false,
    parametros: {
      listagem: null,
      page: 1,
      search: null,
    },
    pagination: PAGINATION_OPTIONS,
    total_de_registros: 0,
    search: "",
    filtro: {
      cliente_id: null,
      forma_pagamento: null,
      situacao: null,
      data_inicial: null,
      data_final: null,
      vendedor_id: null,
    },
    filtrar: false,
  },

  getters: {
    total_lista_pedidos(state) {
      return state.pedidos.length;
    },
  },

  mutations: {
    SET_PEDIDOS(state, payload) {
      let { total, data } = payload;
      state.total_de_registros = total;
      state.pedidos = data;
    },

    listar(state, pedidos) {
      state.pedidos = pedidos;
    },

    abrir(state, pedido) {
      state.pedido = pedido;
    },

    salvar(state, pedido) {
      state.pedidos.unshift(pedido);
      state.pedido = pedido;
    },

    atualizar(state, pedido) {
      let index = state.pedidos.findIndex((pedido_) => pedido_.id == pedido.id);
      if (index > -1) {
        state.pedidos.splice(index, 1, pedido);
      }
    },

    excluir(state, id) {
      let pedido = state.pedidos.find((pedido) => pedido.id == id);
      if (pedido) {
        pedido.situacao = "Cancelado";
      }
    },

    update_parametros(state, parametros) {
      state.parametros = parametros;
    },

    set_paginacao(state, paginacao) {
      state.paginacao = {
        paginas: paginacao.last_page,
        registros: paginacao.total,
      };
    },

    set_registros(state, registros) {
      state.registros = registros;
    },

    set_listagem(state, listagem) {
      state.parametros.listagem = listagem;
    },

    SET_PAGE(state, page) {
      state.pagination.page = page;
    },

    set_atualizar(state, atualizar) {
      state.atualizar = atualizar;
    },

    SET_SEARCH(state, search) {
      state.search = search;
    },

    UPDATE_PAGINATION(state, pagination) {
      state.pagination = pagination;
    },

    SET_TOTAL(state, total) {
      state.total_de_registros = total;
    },

    set_novo(state) {
      state.pedidos[0].novo = true;
    },

    UNSET_PEDIDO(state) {
      state.pedido = null;
    },

    SET_FILTRO(state, filtro) {
      state.filtro = filtro;
    },

    SET_FILTRAR(state, filtrar) {
      state.filtrar = filtrar;
    },

    LIMPAR_FILTRO(state) {
      state.filtro = {
        cliente_id: null,
        forma_pagamento: null,
        situacao: null,
        data_inicial: null,
        data_final: null,
        vendedor_id: null,
      };
    },
  },

  actions: {
    async listar({ commit, state }, lista) {
      commit("LOADING_ON", null, { root: true });

      const { sortBy, sortDesc, page, itemsPerPage } = state.pagination;

      const parametros = {
        ...state.filtro,
        page,
        search: state.search,
        itemsPerPage,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
      };

      parametros.sortBy = parametros.sortBy == "cliente.razao" ? "nome" : parametros.sortBy;

      let pedidos = await pedidosApi.listar(parametros);
      commit("listar", pedidos.data);
      commit("SET_TOTAL", pedidos.total);
      commit("LOADING_OFF", null, { root: true });
    },

    async abrir({ commit }, id) {
      commit("LOADING_ON", null, { root: true });
      let pedido = await pedidosApi.abrir(id);
      commit("abrir", pedido);
      commit("LOADING_OFF", null, { root: true });
    },

    async copiarPedido({ commit }, id) {
      commit("LOADING_ON", null, { root: true });
      let pedido = await pedidosApi.copiar(id);
      commit("abrir", pedido);
      commit("LOADING_OFF", null, { root: true });
    },

    async salvar({ commit }, pedido) {
      let novo_pedido = await pedidosApi.salvar(pedido);
      commit("set_atualizar", true);
      commit("salvar", novo_pedido);
    },
    
    async atualizar({ commit }, pedido) {
      let {pedido: pedido_atualizado} = await pedidosApi.atualizar(pedido);
      // commit('set_atualizar', true);
      commit("abrir", pedido_atualizado);
    },

    async finalizarPedido({ commit }, pedido) {
      await pedidosApi.finalizar(pedido);
      commit("atualizar", pedido);
    },

    async excluir({ commit }, id) {
      await pedidosApi.excluir(id);
      commit("excluir", id);
    },

    async atualizarestoque({ commit }, produto) {
      await pedidosApi.atualizarestoque(produto);
    },

    async adicionaritem({ commit }, dados) {
      await pedidosApi.adicionaritem(dados);
    },

    async removeritem({ commit }, dados) {
      await pedidosApi.removeritem(dados);
    },

    buscarProdutoPorReferencia({ commit }, referencia) {
      return produtosApi.buscarProdutoPorReferencia(referencia);
    },

    async faturar({ commit }, post) {
      return await pedidosApi.faturar(post);
    },

    async faturas({ commit }, pedido_id) {
      commit("LOADING_ON", null, { root: true });
      let pedido = await pedidosApi.faturas(pedido_id);
      commit("LOADING_OFF", null, { root: true });
      return pedido;
    },

    async estornar({ commit }, pedido_id) {
      return await pedidosApi.estornar(pedido_id);
    },

    async impressaoTermica({ commit }, pedido_id) {
      await pedidosApi.impressaoTermica(pedido_id);
    },

    async vendasdiarias({ commit }, filtro) {
      await pedidosApi.vendasdiarias(filtro);
    },
  },
};
